var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.saveHandler.apply(null, arguments)}}},[_c('Breadscrumbs',{attrs:{"links":[
        {
          name: 'TechnologyCenter',
          to: {
            name: 'TechnologyCenter'
          }
        },
        {
          name: 'Create',
          to: {
            name: 'TechnologyCreate',
          }
        }
      ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("新增技術")]),_c('v-spacer'),_c('button',{staticClass:"btn mr-5",on:{"click":_vm.cancelHandler}},[_c('span',[_vm._v("取消")])]),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('span',[_vm._v("儲存")])])],1)],1),_c('TechnologyCreateEdit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }